export const NEW_DOMAIN = 'app.gnosis.io';
